import { Service } from './types';

export type StopRequest =
    | { path: 'services/scale'; body: { id: string; replicas: 0; expected_revision_number: number } }
    | {
          path: 'services/update';
          body: { id: string; spec: Record<string, unknown>; expected_revision_number: number };
      };

export function buildStopRequest(service: Service): StopRequest {
    if (service.spec.replicas != null) {
        return {
            path: 'services/scale',
            body: {
                id: service.id,
                replicas: 0,
                expected_revision_number: service.target_revision_number,
            },
        };
    }
    const retainedSpec = { ...service.spec };
    delete retainedSpec.autoscaling;
    return {
        path: 'services/update',
        body: {
            id: service.id,
            spec: { ...retainedSpec, replicas: 0 },
            expected_revision_number: service.target_revision_number,
        },
    };
}
